/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum NumEmployeesFilter {
    HAS_EMPLOYEES = 'hasEmployees',
    NO_EMPLOYEES = 'noEmployees',
}
